import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { Button, ExclamationTriangleIcon, Text } from "@sundae/ui-toolkit";
import cx from "classnames";
import { useWalletLoadingState } from "@sundaeswap/wallet-lite";
import { Actions, useAppContext } from "../../stores";
import { useBrandConfig } from "../../hooks";
export const ConnectWalletNotice = () => {
    const { t } = useI18N();
    const { ready } = useWalletLoadingState();
    const { dispatch } = useAppContext();
    const brand = useBrandConfig();
    return (_jsxs("div", { className: "mx-auto my-8 min-w-[200px] text-center", children: [_jsx(ExclamationTriangleIcon, { width: 75, height: 75, className: "mx-auto mb-8" }), _jsx(Text, { tag: "h4", size: "3xl", weight: "bold", children: t("errors.wallet.not_connected_title") }), _jsx(Text, { tag: "p", children: t("errors.wallet.not_connected_description") }), _jsx(Button, { className: cx(brand?.classes.buttons.all, brand?.classes.buttons.colored, "mx-auto mt-8"), variant: "colored", onClick: () => {
                    Actions.setConnectWalletOpen(true, dispatch);
                }, disabled: !ready, children: t("wallet.button_connect") })] }));
};
export default ConnectWalletNotice;
//# sourceMappingURL=ConnectWalletNotice.js.map